// @flow strict

import React from "react";
import type {
  Store,
  RegisteredStore,
  Agent,
  Equipo,
} from "~robin-hood/redux/store";
import { GROUP_CREATOR, AGENT_NAME } from "~robin-hood/redux/store";
import { now, secondsToTarget } from "~common/utils";
import { TOTAL_SECONDS, EXTRA_SECONDS } from "~robin-hood/utils";
import classnames from "~common/classnames";
import { Modal } from "react-overlays";
import {
  useFirestore,
  // $FlowFixMe[missing-export]
  SuspenseWithPerf,
} from "reactfire";
import styles from "./RegistroEquipoForm.module.css";
import button from "~robin-hood/components/Button.module.css";
import modal from "~robin-hood/components/Modal.module.css";

type FormProps = {
  firestore: Firestore,
  className?: string,
  done?: boolean,
  updateStore: (Store) => void,
};

export function RegistroEquipoForm(
  props: $Diff<FormProps, { firestore: Firestore }>
): React$Node {
  return (
    <SuspenseWithPerf fallback={null} traceId={"registro-equipo"}>
      <RegistroEquipoFormWithFirebase {...props} />
    </SuspenseWithPerf>
  );
}

function RegistroEquipoFormWithFirebase(
  props: $Diff<FormProps, { firestore: Firestore }>
) {
  const firestore = useFirestore();
  return <RegistroEquipoFormClass {...props} firestore={firestore} />;
}
type FormState = {
  equipo: string,
  players: string,
};
class RegistroEquipoFormClass extends React.PureComponent<
  FormProps,
  FormState
> {
  state: FormState = {
    equipo: "",
    players: "",
  };

  render(): React$Node {
    const { updateStore, firestore, done, className } = this.props;
    return (
      <div className={classnames(styles.formWrapper, className)}>
        <CrearSection
          done={done}
          updateStore={updateStore}
          firestore={firestore}
        />
        <UnirseSection
          firestore={firestore}
          done={done}
          updateStore={updateStore}
          endAnimation={() => {
            updateStore({ hasSeenInitialText: true });
          }}
        />
      </div>
    );
  }
}
type CrearSectionProps = {
  firestore: Firestore,
  done?: boolean,
  onAnimationEnd?: () => void,
  updateStore: (Store) => void,
};

function _doCreateEquipo(
  firestore: Firestore,
  updateStore: (Store) => void,
  equipo: string,
  players: string
): Promise<string> {
  console.log(equipo);
  return firestore
    .collection("equipos")
    .add({
      name: equipo.trim(),
      players: parseInt(players, 10),
      creation: now(),
      agents: [GROUP_CREATOR],
    })
    .then((response) => {
      console.log("created !", response);
      return response.id;
    });
}

export function CrearSection(props: CrearSectionProps): React$Node {
  const { firestore, updateStore } = props;
  const [equipo, setEquipo] = React.useState<?Equipo>();
  const [name, setName] = React.useState<string>("");
  const [searching, setSearching] = React.useState<boolean>(false);
  const [players, setPlayers] = React.useState<string>("");
  const [open, setOpen] = React.useState<boolean>(false);
  const valid =
    name !== "" &&
    players !== "" &&
    name.length < 40 &&
    parseInt(players, 10) >= 2 &&
    parseInt(players, 10) <= 6;

  function doCreate() {
    if (valid) {
      setSearching(true);
      _doCreateEquipo(firestore, updateStore, name, players).then((id) => {
        setSearching(false);
        setEquipo({
          id,
          name,
          players: parseInt(players, 10),
          pruebas: {},
          // agents: [GROUP_CREATOR],
        });
      });
    }
  }
  return (
    <div className={styles.create}>
      <span
        className={classnames(button.button, open && button.open)}
        onClick={() => {
          setOpen(true);
        }}
      >
        Crear
      </span>
      <Modal
        show={open}
        onHide={() => {
          setOpen(false);
        }}
        renderBackdrop={(props) => (
          <div className={modal.backdrop} {...props}></div>
        )}
      >
        <div className={classnames(modal.modal)}>
          {equipo == null && (
            <div
              className={classnames(
                modal.modalContent,
                "animate__animated animate__fadeIn"
              )}
            >
              <h1 className={modal.modalTitle}>Crea tú equipo</h1>
              <div className={styles.fields}>
                <div className={styles.labels}>
                  <label className={styles.label}>Nombre del equipo: </label>
                  <label className={styles.label}>Número de jugadores: </label>
                </div>
                <div className={styles.values}>
                  <form
                    onSubmit={(e) => {
                      console.log("submit");
                      e.preventDefault();
                      doCreate();
                    }}
                  >
                    <input
                      autoFocus
                      type="text"
                      defaultValue={name}
                      maxLength="40"
                      className={styles.value}
                      onChange={(e) => setName(e.target.value)}
                    />
                    <input
                      type="number"
                      min="2"
                      max="6"
                      placeholder="2 a 6"
                      defaultValue={players}
                      className={classnames(styles.value, styles.last)}
                      onChange={(e) => setPlayers(e.target.value)}
                    />
                    <input type="submit" className={styles.hidden} />
                  </form>
                </div>
              </div>
              <div className={modal.modalSubmit}>
                <span
                  className={classnames(
                    button.button,
                    button.alt,
                    !valid && button.disabled
                  )}
                  onClick={() => {
                    doCreate();
                  }}
                >
                  {searching ? (
                    <span
                      className={classnames(
                        styles.spin,
                        "fa fa-spin fa-circle-notch"
                      )}
                    ></span>
                  ) : (
                    "Crear"
                  )}
                </span>
              </div>
            </div>
          )}
          {equipo != null && (
            <div
              className={classnames(
                modal.modalContent,
                "animate__animated animate__fadeIn"
              )}
            >
              <h1 className={classnames(modal.modalTitle)}>
                {`Equipo "${equipo.name}" creado`}
              </h1>
              <p>
                Tu nombre en clave será{" "}
                <b>Agente {AGENT_NAME.get(GROUP_CREATOR)}</b> y el código de tu
                equipo es: <b>{equipo.id}</b>
              </p>
              <p>
                Compártelo con tús compañeros para que puedan unirse a tu
                equipo.
              </p>
              <div className={classnames(modal.modalSubmit)}>
                <span
                  className={classnames(button.button, button.alt)}
                  onClick={() => {
                    updateStore({
                      equipo,
                      // On creation, we automatically assign player
                      agent: GROUP_CREATOR,
                    });
                  }}
                >
                  Continuar
                </span>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
}

type UnregisteredEquipo = $Diff<Equipo, { id: string }>;

export function UnirseSection({
  updateStore,
  firestore,
  done,
  endAnimation,
}: {
  done?: boolean,
  endAnimation: () => void,
  updateStore: (RegisteredStore) => void,
  firestore: Firestore,
}): React$Node {
  const [token, setToken] = React.useState<string>("");
  const [localAgent, setLocalAgent] = React.useState<?Agent>();
  const [open, setOpen] = React.useState<boolean>(false);
  const [searching, setSearching] = React.useState<boolean>(false);
  const [searched, setSearched] = React.useState<boolean>(false);
  const [equipo, setEquipo] = React.useState<?Equipo>();

  function _doSetAgent(newAgent: Agent) {
    setLocalAgent(newAgent);
  }

  function _doSearch(token: string) {
    setSearching(true);
    firestore
      .collection<UnregisteredEquipo>("equipos")
      .doc(token.trim())
      .get()
      .then((response) => {
        setSearching(false);
        setSearched(true);
        if (!response.exists) {
          console.log("Not found !", response);
        } else {
          const equipo = response.data();
          console.log("Found !", equipo);

          const expired = isExpired(equipo);
          switch (expired) {
            case "new":
            case "started":
              setEquipo({ ...equipo, id: token });
              break;
            case "end":
              // TODO - handle case where equipo is already finished
              break;
          }
        }
      });
  }
  function isExpired(equipo: UnregisteredEquipo): "new" | "started" | "end" {
    if (!equipo.startTime) {
      return "new";
    }
    if (equipo.endTime) {
      return "end";
    }
    const seconds = secondsToTarget(equipo.startTime, TOTAL_SECONDS);
    if (seconds > 0) {
      return "started";
    }
    if (!equipo.extraTimeStart) {
      return "started";
    }

    const extraSeconds = secondsToTarget(equipo.extraTimeStart, EXTRA_SECONDS);
    if (extraSeconds > 0) {
      return "started";
    } else {
      return "end";
    }
  }

  function _doJoin(equipo: Equipo, agent: Agent) {
    updateStore({ equipo, agent });
  }
  const disabled =
    (searched && equipo == null) || token === "" || token.length < 18;
  return (
    <div className={styles.unirse}>
      <span
        className={classnames(button.button, open && button.open)}
        onClick={() => {
          setOpen(true);
        }}
      >
        Buscar
      </span>
      <Modal
        show={open}
        onHide={() => {
          setOpen(false);
        }}
        renderBackdrop={(props) => (
          <div className={modal.backdrop} {...props}></div>
        )}
      >
        <div className={modal.modal}>
          {equipo == null && (
            <div
              className={classnames(
                modal.modalContent,
                "animate__animated animate__fadeIn"
              )}
            >
              <h1 className={modal.modalTitle}>Únete a un equipo existente:</h1>
              <div className={styles.fields}>
                <div className={styles.labels}>
                  <span className={styles.label}>Código: </span>
                </div>
                <div className={styles.values}>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      !searching && !disabled && _doSearch(token);
                    }}
                  >
                    <input
                      autoFocus
                      name="token"
                      type="text"
                      defaultValue={token}
                      className={styles.value}
                      onChange={(e) => {
                        setSearched(false);
                        setToken(e.target.value);
                      }}
                    />
                  </form>
                </div>
              </div>
              <div className={modal.modalSubmit}>
                {searched && (
                  <div className={modal.modalSubmitResult}>
                    <span>
                      El equipo no existe o ya ha completado la misión.
                      Comprueba tu código e inténtalo de nuevo.
                    </span>
                  </div>
                )}
                <span
                  className={classnames(
                    button.button,
                    button.alt,
                    disabled && button.disabled
                  )}
                  onClick={() => {
                    !searching && !disabled && _doSearch(token);
                  }}
                >
                  {searching ? (
                    <span
                      className={classnames(
                        styles.spin,
                        "fa fa-spin fa-circle-notch"
                      )}
                    ></span>
                  ) : (
                    "Buscar"
                  )}
                </span>
              </div>
            </div>
          )}
          {equipo != null && (
            <div
              className={classnames(
                modal.modalContent,
                "animate__animated animate__fadeIn"
              )}
            >
              <h1 className={classnames(modal.modalTitle, styles.center)}>
                {`¡Equipo "${equipo.name}" encontrado!`}
              </h1>
              <div className={classnames(styles.found, styles.center)}>
                <p>
                  Habla con tus compañeros y elegid un alias distinto cada uno
                  para poder completar la misión. Es importante que{" "}
                  <b>todos los alias</b> estén asignados. Para poder cambiarlo,
                  tendréis que abandonar el equipo y volver a buscarlo.
                </p>
                <Agents
                  players={equipo.players}
                  // agents={equipo.agents}
                  selected={localAgent}
                  onSelect={(agent) => _doSetAgent(agent)}
                />
              </div>
              <div
                className={classnames(
                  modal.modalSubmit,
                  styles.seleccionarAgente
                )}
              >
                <span
                  className={classnames(
                    button.button,
                    button.alt,
                    !localAgent && button.disabled
                  )}
                  onClick={() => {
                    localAgent && _doJoin(equipo, localAgent);
                  }}
                >
                  Seleccionar Agente{" "}
                  {localAgent ? AGENT_NAME.get(localAgent) : null}
                </span>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
}

type AgentsProps = {
  players: number,
  // agents: Array<Agent>,
  selected: ?Agent,
  onSelect: (Agent) => void,
};

function Agents({
  // agents,
  players,
  selected,
  onSelect,
}: AgentsProps): React$Node {
  let iterator;
  switch (players) {
    case 2:
      iterator = [
        //
        [GROUP_CREATOR, "1"],
      ];
      break;
    case 3:
      iterator = [
        //
        [GROUP_CREATOR, "1", "2"],
      ];
      break;
    case 4:
      iterator = [
        //
        [GROUP_CREATOR, "1", "2", "3"],
      ];
      break;
    case 5:
      iterator = [
        //
        [GROUP_CREATOR],
        ["1", "2", "3", "4"],
      ];
      break;
    case 6:
    default:
      iterator = [
        //
        [GROUP_CREATOR, "1", "2"],
        ["3", "4", "5"],
      ];
  }
  return (
    <div className={styles.agents}>
      {iterator.map((row) => {
        return (
          <div key={row.join("|")} className={styles.agentsRow}>
            {row.map((agent) => {
              // const wasSelected = agents.includes(agent);
              return (
                <div
                  key={agent}
                  className={classnames(
                    styles.agent,
                    agent === selected && styles.agentSelected
                    // wasSelected && styles.agentSelectedEquipo
                  )}
                  onClick={() => {
                    onSelect(agent);
                  }}
                >
                  Agente {AGENT_NAME.get(agent)}{" "}
                  {agent === GROUP_CREATOR && "(creador)"}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
